import classNames from 'classnames'
import * as React from 'react'

import styles from '../CleanupForm.css'

const MIN_TEXTAREA_ROWS = 3
const MAX_TEXTAREA_ROWS = 10
type Props = {
  value?: string
  disabled?: boolean
  onChange: (value: string) => unknown
  className?: string
  id?: string
}

function ArtifactsSection({value, onChange, disabled, className, id}: Props) {
  const onValueChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value),
    [onChange],
  )
  const currentLineCount = value != null ? value.split('\n').length : 0
  let currentTextareaRowsCount = MIN_TEXTAREA_ROWS

  if (currentLineCount > MAX_TEXTAREA_ROWS) {
    currentTextareaRowsCount = MAX_TEXTAREA_ROWS
  } else if (currentLineCount > MIN_TEXTAREA_ROWS) {
    currentTextareaRowsCount = currentLineCount
  }

  return (
    <div className={classNames(styles.row, className)}>
      <div className={classNames(styles.inputs, styles.artifactsWrapper)}>
        <textarea
          id={id}
          disabled={disabled}
          className={classNames(styles.textarea, styles.input)}
          placeholder={'Add pattern'}
          onChange={onValueChange}
          value={value}
          rows={currentTextareaRowsCount}
        />
        <div className={styles.hint}>
          <div>{'Newline-separated paths in the form of [+:/-:]<Ant-style pattern wildcard>'}</div>
        </div>
      </div>
    </div>
  )
}

export default React.memo<Props>(ArtifactsSection)
